module.exports = __webpack_public_path__ + "img/exclamation.e5f42b43.svg";